module.exports = __webpack_public_path__ + "img/maintenance-1.c728b2db.gif";